import { GetterTree } from "vuex";
import { IAssessmentState as AssessmentState } from "@/store/modules/assessment/types";
import { RootState } from "@/store/types";

type AssessmentGetterTree = GetterTree<AssessmentState, RootState>;

export const getters: AssessmentGetterTree = {
  sectionTime(state: AssessmentState): number {
    const { section } = state;
    if (section) {
      return section.time;
    }

    return 0;
  },

  isOngoingSection(state: AssessmentState): boolean {
    const { section } = state;
    if (section && section.answers) {
      return Object.keys(section.answers).length > 0;
    }

    return false;
  },

  getSection(state: AssessmentState): any {
    const { section } = state;
    if (section) {
      return section;
    }
  },

  getSections(state: AssessmentState): any {
    const { sections } = state;
    if (sections) {
      return sections;
    }
  },
};
